import { makeStyles } from "@material-ui/core";
import { ContentState, Editor, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import * as React from "react";

const useStyles = makeStyles({
  wrapper: {
    "& .public-DraftStyleDefault-block": {
      margin: 0
    },
    "& .public-DraftStyleDefault-ol": {
      margin: 0
    },
    "& .public-DraftStyleDefault-orderedListItem": {
      marginLeft: "1.2em"
    },
    "& .public-DraftStyleDefault-ul": {
      margin: 0
    },
    "& .public-DraftStyleDefault-unorderedListItem": {
      marginLeft: "1.2em"
    },
    color: "#4d4d4e",
    fontSize: "1.4rem"
  }
});

interface IOwnProps {
  responseHTML: string;
}

const htmlToDraftState = (html: string) =>
  EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(html).contentBlocks));

const ResponseContent = ({ responseHTML }: IOwnProps) => {
  const handleChange = React.useCallback(() => null, []);
  const classes = useStyles();
  const editorState = htmlToDraftState(responseHTML);

  return (
    <div className={classes.wrapper}>
      <Editor onChange={handleChange} editorState={editorState} readOnly />
    </div>
  );
};

export default React.memo(ResponseContent);
